export default "assets/images/medaille-9b98c28a.png";